import React, { useEffect, useState } from "react";
import { Route, RouteProps } from "react-router";
import { AdminService, UserService } from "../generated";

interface AdminRouteProps extends RouteProps {
  component: React.ComponentType<any>;
}

const AdminRoute = (props: AdminRouteProps) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsloading] = useState<boolean | null>(null);

  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        setIsloading(true);

        const isAuthenticated = await UserService.userIsAuthenticated();
        setIsAuthenticated(isAuthenticated);

        const testAdmin = await AdminService.adminPing();
        const isAdmin = Object.prototype.hasOwnProperty.call(testAdmin, "pong");
        setIsAdmin(isAdmin);
      } catch (error) {
        setIsAdmin(false);
        console.error("Error checking admin status:", error);
      } finally {
        setIsloading(false);
      }
    };

    checkAdminStatus();
  }, []);

  if (isLoading === false) {
    if (isAuthenticated && !isAdmin) {
      return <div>Please login with a Mastercard account</div>;
    }

    const { component: Component, ...rest } = props;

    return <Route {...rest} component={Component} />;
  } else {
    return <p>Loading...</p>;
  }
};

export default AdminRoute;
